import request from './request';
import type { iRegisterData } from '@/types/index';

export const register = (data: iRegisterData) =>
  request({
    url: '/carbon-auth/public/register/usr/pwd',
    method: 'post',
    data
  });
